import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const Grids = Object.freeze({
    mobile: {
        columns: 4,
        gutter: '3vw',
    },
    tablet: {
        columns: 8,
        gutter: Spacings.large,
    },
    desktop: {
        columns: 12,
        gutter: Spacings.xLarge,
    },
});
export default Grids;
